// 타입 정의
type ConvertibleValue =
  | string
  | number
  | boolean
  | null
  | undefined
  | ConvertibleValue[]
  | { [key: string]: ConvertibleValue };

// 카멜 케이스를 언더바 케이스로 변환
export const camelToSnakeCase = (input: ConvertibleValue): ConvertibleValue => {
  if (Array.isArray(input)) {
    return input.map((item) => camelToSnakeCase(item)); // 배열일 경우 각 요소를 변환
  } else if (input !== null && typeof input === 'object') {
    const converted: Record<string, ConvertibleValue> = {};
    for (const key in input) {
      if (Object.prototype.hasOwnProperty.call(input, key)) {
        const value = input[key];
        const snakeCaseKey = key.replace(/[A-Z]/g, (match: string) => '_' + match.toLowerCase());
        converted[snakeCaseKey] = camelToSnakeCase(value); // 내부 객체도 재귀적으로 변환
      }
    }
    return converted;
  }
  return input; // 기본값(객체나 배열이 아닐 경우)은 그대로 반환
};

// 언더바 케이스를 카멜 케이스로 변환
// export const snakeToCamelCase = (input: string): string => {
//   return input.replace(/_(?<char>[a-z])/g, (_, char) => char.toUpperCase());
// };
// 테스트

export const snakeToCamelCase = (input: Record<string, ConvertibleValue>): Record<string, ConvertibleValue> => {
  const converted: Record<string, ConvertibleValue> = {};
  for (const key in input) {
    if (Object.prototype.hasOwnProperty.call(input, key)) {
      const value = input[key];
      const camelCaseKey = key.replace(/_(?<char>[a-z])/g, (_, char) => char.toUpperCase());
      converted[camelCaseKey] = value;
    }
  }
  return converted;
};
